<template>
  <section class="container">
    <!-- Vista seleccionar usuarios -->
    <div class="section__users">
      <div class="box">
        <div class="container__search">
          <a-checkbox
            @change="handleSelectAllActiveUsers($event)"
            :checked="allItemsSelected"
            class="checkbox__select"
          >
            Seleccionar todo
          </a-checkbox>
          <a-input
            placeholder="Busca los usuarios aquí"
            class="search__users"
            @change="handleSearchActiveUsers"
          >
            <template #suffix>
              <SearchOutlined style="color: #8c8c8c" />
            </template>
          </a-input>
        </div>

        <div id="style-scroll-agente" class="scrollbar-agent">
          <div class="container-items-agent" v-if="profilesGroup">
            <div
              v-for="profileName in Object.keys(profilesGroup)"
              :key="profileName"
              class="item__agent"
            >
              <div class="select__users">
                <a-checkbox
                  :checked="allItemsSelectedByProfile(profileName)"
                  @change="handleSelectActiveUsersByProfile($event, profileName)"
                  ><span class="profile__name">
                    {{ profileName }}
                  </span>
                </a-checkbox>
              </div>
              <div
                v-for="user in profilesGroup[profileName]"
                :key="user.id"
                class="container__users"
              >
                <a-checkbox
                  :checked="user.added"
                  @change="handleSelectSingleActiveUser($event, user.id)"
                  class="container__flex"
                >
                  <div>
                    <a-tooltip placement="top" v-if="user.fullname?.length > 24">
                      <template #title>
                        <span >{{ user.fullname }}</span>
                      </template>
                      <p class="text__name">
                        {{ user.fullname }}
                      </p>
                    </a-tooltip>
                    <p v-else class="text__name">
                      {{ user.fullname }}
                    </p>
                  </div>
                </a-checkbox>
                <!-- <div class="container__image">
                  <img class="user__icon" :src="user.picture" v-if="user.picture" alt="perfil" />
                  <img
                    class="user__icon"
                    src="@/app/users/assets/profiles/smile.svg"
                    alt="perfil"
                    v-else
                  />
                </div> -->

                <div v-if="user?.picture">
                  <img class="user__icon" :src="user?.picture" alt="perfil" />
                </div>
                <div
                  v-else
                  :class="user.role?.name === 'Agente' ? 'background__agent' : ''"
                  class="background__profile"
                >
                  <img
                    v-if="user.icon"
                    class="user__profile"
                    :class="user.role?.name === 'Agente' ? 'user__agente' : ''"
                    :src="getProfileImage(user?.icon || iconDefault)"
                    alt="perfil"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SearchOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";
import { debounce } from "lodash";

export default defineComponent({
  components: {
    SearchOutlined,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    strategy: {
      required: true,
      type: Object,
    },
    inactivateUser: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    profilesGroup() {
      const profilesGroup = this.$store.getters["getProfilesGroupContact"];
      // Si inactivateUser es true, filtrar el usuario con record.id
      if (this.inactivateUser) {
        return Object.keys(profilesGroup).reduce((filteredGroups, profile) => {
          filteredGroups[profile] = profilesGroup[profile].filter(
            (user) => user.id !== this.record.id
          );
          return filteredGroups;
        }, {});
      }
      return profilesGroup;
    },
    allItemsSelected() {
      return !Object.values(this.profilesGroup).some((profileGroup) =>
        profileGroup.some((user) => !user.added)
      );
    },
    iconDefault() {
      return "smile.svg";
    },
  },
  async created() {
    await this.$store.dispatch("fetchActiveUsers");
  },
  methods: {
    getProfileImage(profile) {
      return new URL(`../../../users/assets/profiles/${profile}`, import.meta.url).href;
    },
    allItemsSelectedByProfile(profileName) {
      return !this.profilesGroup[profileName].some((item) => !item.added);
    },
    handleSearchActiveUsers: debounce(async function (event) {
      await this.$store.dispatch("fetchSearchActiveUsers", event.target.value);
     }, 300), 
    handleSelectAllActiveUsers(event) {
      this.$store.dispatch("selectAllActiveUsers", event.target.checked);
    },
    handleSelectActiveUsersByProfile(event, profileName) {
      this.$store.dispatch("selectActiveUsersByProfile", {
        status: event.target.checked,
        profileName,
      });
    },
    handleSelectSingleActiveUser(event, userId) {
      this.$store.dispatch("selectSingleActiveUser", {
        status: event.target.checked,
        userId,
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  box-sizing: border-box
  border-radius: 2px
  padding: 10px 0 21px
  .box
    background: $white
    border: 1px solid $gray-4
    box-sizing: border-box
    border-radius: 2px
    display: flex
    flex-direction: column
    height: 394px

.container__search
  display: flex
  flex-direction: column
  margin-bottom: 10px

.item__agent
  margin-bottom: 8px
  align-items: center
  margin-left: 14px

.title-agents
  margin-bottom: 0px
  font-weight: 600
  color: $gray-9

.selection-agents
  width: 85%
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 3px
  height: 25px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0px
  justify-content: space-between
  margin-left: 40px
  margin-top: 10px
input[type="checkbox"]
  width: 16px
  height: 16px
  margin-right: 8px
input:checked
  background-color: $blue-6
  &:hover
    background-color: $blue-6

.scrollbar-agent
  float: left
  height: 500px
  overflow-y: scroll
  padding-right: 10px

.label-agent
  padding-left: 7px
  display: flex
  align-items: center

#style-scroll-agente::-webkit-scrollbar-track
  border-radius: 10px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar
  width: 5px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar-thumb
  border-radius: 10px
  background-color: #C4C4C4

.section__users
  margin-right: 12px

.icon--close
  color: $gray-8
  margin-left: 5px

.section__users--selected
  width: 45%

.checkbox__select
  border-bottom: 1px solid #E8E8E8
  margin-bottom: 10px
  padding: 8px 12px

.search__users
  margin-left: 5px
  width: 97%
  margin-top: -5px

.container__users
  margin-top: 10px
  display: flex
  align-items: center
  justify-content: space-between
  margin-left: 20px

.select__users
  border-bottom: 1px solid #E8E8E8

.profile__name
  margin-left: 7px
  font-weight: 600

.container__selected
  margin-top: 20px
  margin-left: 10px

.container__profile
  border-bottom: 1px solid #E8E8E8

.selectedGroup
  width: 85%
  background: #e6f7ff
  border: 1px solid #91d5ff
  box-sizing: border-box
  border-radius: 3px
  height: 30px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0
  justify-content: space-between
  margin-left: 40px
  margin-top: 10px
  align-items: center

.container__image
  margin-right: 10px

.container__information
  margin: 0 auto
  text-align: center
  margin-top: 90px

.infoUser
  margin-top: 40px
  color: $gray-6

.text__name
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis
  margin-right: 4px
  width: 180px
  margin-bottom: 0

.container__flex
  display: flex
  align-items: center

.user__icon
  width: 22px
  height: 22px
  margin: 6px
  border-radius: 50%

.background__profile
  background-color: rgb(230, 247, 255)
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px

.background__agent
  background: #FFF6E2
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px

.user__profile
  width: 22px
  height: 22px
  margin: 6px
  filter: invert(62%) sepia(84%) saturate(1521%) hue-rotate(178deg) brightness(103%) contrast(99%)

.user__agente
  width: 22px
  height: 22px
  margin: 6px
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)
</style>
